export default "__VITE_ASSET__DWwcrihP__"